export enum PointOfSalesActionTypes {
    SET_POINT_OF_SALES = 'pos/setAllPos',
    SET_POINT_OF_SALE = 'pos/setPos',
    LOADING_POINT_OF_SALES = 'pos/loadingPos'
}